import ArrowLeft from 'svg/ArrowLeft';
import { Button } from 'components/Button';
import AddressField from './AddressField';
import type { AddVenueState } from '../useAddVenue';

type Props = Pick<AddVenueState, 'manualSearch' | 'handleManualInput' | 'exitManualMode'>;

export default function ManualAddressForm({
  manualSearch,
  handleManualInput,
  exitManualMode,
}: Props) {
  return (
    <div className="flex flex-col items-start gap-ds-xl px-ds-lg py-ds-lg lg:px-ds-3xl lg:py-ds-xl">
      {/* Below lg the footer carries Go back. */}
      <Button
        variant="secondary"
        size="md"
        isInline
        className="max-lg:hidden"
        iconLeft={<ArrowLeft className="h-4 w-4" />}
        onClick={exitManualMode}
      >
        Go back
      </Button>
      <div className="flex w-full flex-col gap-ds-sm lg:gap-ds-lg lg:rounded-[1.25rem] lg:border lg:border-color-border-hover-lightmode lg:bg-color-bg-lightmode-primary lg:p-[1.4375rem] lg:shadow-[0px_4px_16px_rgba(0,0,0,0.08)] dark:lg:border-color-border-hover-darkmode dark:lg:bg-color-bg-darkmode-primary">
        <label
          htmlFor="add-venue-manual-address"
          className="typography-product-subheading text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary lg:text-color-text-lightmode-primary dark:lg:text-color-text-darkmode-primary"
        >
          Enter address manually
        </label>
        <AddressField
          id="add-venue-manual-address"
          variant="field"
          search={manualSearch}
          placeholder="Type full address"
          onInputChange={handleManualInput}
        />
      </div>
    </div>
  );
}
